var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconViewInNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.498 3.5a.745.745 0 01-.729-.748.755.755 0 01.768-.752l3.464.055a.994.994 0 01.998 1l-.009 3.403a.757.757 0 01-.792.752.745.745 0 01-.71-.748l.004-1.909-8.365 8.365a.75.75 0 01-1.06-1.06l8.32-8.32-1.889-.038zm.002 16v-9L19 9v11a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1h11l-1.5 1.5h-9v13h13z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewInNewTab);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconViewInNewTab.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };